import { render } from "./AnnouncementsView.vue?vue&type=template&id=a5a50d70&scoped=true"
import script from "./AnnouncementsView.vue?vue&type=script&lang=js"
export * from "./AnnouncementsView.vue?vue&type=script&lang=js"

import "./AnnouncementsView.vue?vue&type=style&index=0&id=a5a50d70&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5a50d70"]])

export default __exports__